export const maskText = (email) => {
  if (!email) return "";

  const [localPart, domainPart] = email.split("@");
  if (!domainPart) return email;

  // Mask local part: keep first and last, rest masked
  const firstChar = localPart[0];
  const lastChar = localPart[localPart.length - 1];
  const maskedLocal =
    localPart.length > 2
      ? `${firstChar}${"*".repeat(localPart.length - 2)}${lastChar}`
      : localPart;

  // Handle domain (before TLD)
  const domainSections = domainPart.split(".");
  const mainDomain = domainSections[0];
  const tld = domainSections.slice(1).join("."); // supports .com, .co.uk, etc.

  const domainFirst = mainDomain[0];
  const domainLast = mainDomain[mainDomain.length - 1];
  const maskedDomain =
    mainDomain.length > 2
      ? `${domainFirst}${"*".repeat(mainDomain.length - 2)}${domainLast}`
      : mainDomain;

  return `${maskedLocal}@${maskedDomain}.${tld}`;
};

export const maskPhone = (phone) => {
  if (!phone || phone.length <= 2) return phone; // nothing to mask

  const firstDigit = phone[0];
  const lastDigit = phone[phone.length - 1];

  // mask all middle digits
  const maskedMiddle = "x".repeat(phone.length - 2);

  return `${firstDigit}${maskedMiddle}${lastDigit}`;
};

// export const maskPhoneNumber = (phone) => {
//   if (!phone) return phone;

//   // Remove spaces, dashes, and plus signs
//   let cleaned = phone.replace(/[\s-+]+/g, "");

//   let countryCode = "";
//   let numberPart = cleaned;

//   // Determine if there's an initial country code based on length
//   if (cleaned.length > 10) {
//     const excessDigitsCount = cleaned.length - 10;
//     countryCode = `+${cleaned.substring(0, excessDigitsCount)}`;
//     numberPart = cleaned.substring(excessDigitsCount);
//   }

//   // Focus on last 10 digits for masking
//   if (numberPart.length > 10) {
//     const excessDigitsCount = numberPart.length - 10;
//     numberPart = numberPart.substring(numberPart.length - 10);
//     // Append excess count as '+' sign
//     if (excessDigitsCount > 0) {
//       countryCode = countryCode
//         ? countryCode + " +" + excessDigitsCount
//         : "+" + excessDigitsCount;
//     }
//   }

//   // Mask the number part
//   if (numberPart.length <= 2) return phone;

//   const firstDigit = numberPart[0];
//   const lastDigit = numberPart[numberPart.length - 1];
//   const maskedMiddle = "x".repeat(numberPart.length - 2);
//   const maskedNumber = `${firstDigit}${maskedMiddle}${lastDigit}`;

//   // Return formatted string
//   return countryCode ? `${countryCode} ${maskedNumber}` : maskedNumber;
// };

export const maskPhoneNumber = (phone) => {
  if (!phone) return phone;

  // Keep only digits
  let digits = phone.replace(/\D/g, "");

  digits = digits.slice(-10);

  // If too short
  if (digits.length <= 2) return digits;

  // Mask all except last 2 digits
  return "x".repeat(digits.length - 2) + digits.slice(-2);
};
